module.exports = __webpack_public_path__ + "static/media/soma_icon.4f91dc19.svg";